import { prefixObjectValues as pre } from '../../../utils';

const prefix = 'account-licenses-dea-table';

const pagination = pre(
  {
    total: 'total',
    page: 'page',
    first: 'first',
    last: 'last',
    previous: 'previous',
    next: 'next',
    button: 'button',
  },
  prefix + '-pagination'
);

const columns = pre(
  {
    layout: 'layout',
    deaNum: 'deaNum',
    expiryDate: 'expiryDate',
    issueDate: 'issueDate',
    restrictedFlag: 'restrictedFlag',
    activeFlag: 'activeFlag',
    expiredPill: 'expiredPill',
    deleteAction: 'delete-action',
    editAction: 'edit-action',
  },
  prefix + '-column'
);

const table = pre(
  {
    layout: 'layout',
    row: 'row',
    rowActions: 'row-actions',
    expiredTag: 'expired-tag',
    deaNumSort: 'deaNum-sort',
    issueSort: 'issue-sort',
    expirySort: 'expiry-sort',
    restrictedSort: 'restricted-sort',
    activeSort: 'active-sort',
    editBtn: 'edit-btn',
    deleteBtn: 'delete-btn',
    emptyState: 'empty-state',
  },
  prefix
);

export default {
  ...table,
  columns,
  pagination,
};
